// extracted by mini-css-extract-plugin
module.exports = {"map":"StaticMap_map__5ckdL","controls":"StaticMap_controls__sJfoI"};